import {
    MdEmail,
    MdLink,
    MdNumbers,
    MdAttachMoney,
    MdCalendarToday,
    MdPhone,
    MdBusiness,
    MdPerson,
    MdTextFields,
    MdList,
} from 'react-icons/md';

export const getFormatIcon = (format: string, type?: string, className: string = '') => {
    if (type === 'array') return <MdList className={className} />;
    
    switch (format.toLowerCase()) {
        case 'email': return <MdEmail className={className} />;
        case 'fileurl': return <MdLink className={className} />;
        case 'number': return <MdNumbers className={className} />;
        case 'currency': return <MdAttachMoney className={className} />;
        case 'date': return <MdCalendarToday className={className} />;
        case 'phone': return <MdPhone className={className} />;
        case 'cnpj':
        case 'govtaxid': return <MdBusiness className={className} />;
        case 'cpf':
        case 'socialid': return <MdPerson className={className} />;
        case 'json':
        case 'list': return <MdList className={className} />;
        default: return <MdTextFields className={className} />;
    }
};
